
import { BrowserRouter as Router } from "react-router-dom";
import { Toaster } from "sonner";
import BackgroundWrapper from "@/components/layout/BackgroundWrapper";
import AppRoutes from "@/components/routing/AppRoutes";
import AuthLayout from "@/layouts/AuthLayout";

function App() {
  return (
    <Router>
      <BackgroundWrapper>
        <AuthLayout>
          <AppRoutes />
        </AuthLayout>
        <Toaster position="top-center" />
      </BackgroundWrapper>
    </Router>
  );
}

export default App;
